module.exports = __webpack_public_path__ + "img/teepees-map--en.cb3d3ad4.png";